import { createSlice } from '@reduxjs/toolkit';

const flowStepSlice = createSlice({
  name: 'flowStepList',
  initialState: 
  { step: 'form',
    otpVerified: false,
    fromSummaryPage: false,
  },
  reducers: {
    setStep: (state, action) => {
      state.step = action.payload;
    },
    setOtpVerified: (state, action) => {
      state.otpVerified = action.payload;
    },

    resetStep: () => ({ step: 'form' }), // Reset to default

    setFromSummaryPage: (state, action) => {
      state.fromSummaryPage = true;
      console.log("statestatestate",state);
    }
  },
});

export const { setStep, resetStep, setOtpVerified, setFromSummaryPage } = flowStepSlice.actions;

export default flowStepSlice.reducer;
